<template>
  <UsageExample v-model="tab" :code="code" :tabs="tabs">
    <v-row class="d-flex justify-center">
      <hx-button
        variant="primary"
        label="Helix Toolbar within Helix Modal"
        @click="showHxModalToolbar = true"
      ></hx-button>
      <HxModal
        v-model="showHxModalToolbar"
        title="Print Settings"
        pdf-export
        height="813px"
        width="1045px"
        max-width="1045px"
      >
        <template #content>
          <v-layout height="100%">
            <hx-toolbar
              v-model:collapsed="collapseToolbar"
              header-title="Template Settings"
              pdf-export
              header-icon="mdi-tune-variant"
              width="320"
            >
              <hx-toolbar-body-section-content-block>
                <hx-content-card width="286" height="269" inside-toolbar>
                  <span class="style-07">Content Controls</span>
                  <span class="d-flex justify-space-between style-07">
                    Text Size
                    <hx-select
                      v-model="selectedSize"
                      :items="size"
                      width="73px"
                      single
                      pdf-export
                    />
                  </span>
                  <span class="d-flex justify-space-between style-07">
                    Text Spacing
                    <hx-select
                      v-model="selectedSpacing"
                      :items="spacing"
                      width="73px"
                      single
                      pdf-export
                    />
                  </span>
                  <v-divider :thickness="1"></v-divider>
                  <span class="style-07">Table Options</span>
                  <hx-checkbox v-model="repeatHeaderRow" label="Repeat header row"></hx-checkbox>
                  <hx-checkbox
                    v-model="minimiseTablePadding"
                    label="Minimise table padding"
                  ></hx-checkbox>
                </hx-content-card>
                <div class="d-flex flex-column">
                  <hx-button
                    left-icon="$i-print"
                    size="large"
                    variant="primary"
                    label="Print"
                    class="mt-4 style-08"
                    @click="handlePrintClick"
                  ></hx-button>
                  <hx-button
                    left-icon="$i-save"
                    size="large"
                    variant="secondary"
                    label="Export PDF"
                    class="mt-4 style-08"
                    @click="handleExportPDFClick"
                  ></hx-button>
                  <hx-button
                    left-icon="$i-refresh"
                    size="large"
                    variant="secondary"
                    label="Reset to default"
                    class="mt-4 style-08"
                    @click="handleResetToDefaultClick"
                  ></hx-button>
                </div>
              </hx-toolbar-body-section-content-block>
            </hx-toolbar>

            <v-main class="d-flex align-center justify-center">
              <img :src="screenshotPdfExport" alt="screenshotPdfExport" class="preview-panel" />
            </v-main>
          </v-layout>
        </template>
      </HxModal>
    </v-row>
  </UsageExample>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';
import screenshotPdfExport from '@/assets/screenshotPdfExport.png';

export default {
  name: 'HelixModalToolbar',
  components: { UsageExample },
  setup() {
    const code = `
<hx-button
        variant="primary"
        label="Helix Toolbar within Helix Modal"
        @click="showHxModalToolbar = true"
></hx-button>
<HxModal
    v-model="showHxModalToolbar"
    title="Print Settings"
    pdf-export
    height="813px"
    width="1045px"
    max-width="1045px"
>
    <template #content>
    <v-layout height="100%">
    <hx-toolbar
                v-model:collapsed="collapseToolbar"
                header-title="Template Settings"
                pdf-export
                header-icon="mdi-tune-variant"
            >
        <hx-toolbar-body-section-content-block>
        <hx-content-card>
            <span>Content Controls</span>
            <span class="d-flex justify-space-between align-center">
            Text Size
            <hx-select
                                        v-model="selectedSize"
                                        :items="size"
                                        width="100px"
                                        single
                                        pdf-export
                                        class="ma-1"
                                    />
            </span>
            <span class="d-flex justify-space-between align-center">
            Text Spacing
            <hx-select
                                        v-model="selectedSpacing"
                                        :items="spacing"
                                        width="100px"
                                        single
                                        pdf-export
                                        class="ma-1"
                                     />
            </span>
            <v-divider :thickness="1"></v-divider>
            <span>Table Options</span>
            <hx-checkbox v-model="repeatHeaderRow" label="Repeat header row"></hx-checkbox>
            <hx-checkbox
                                        v-model="minimiseTablePadding"
                                        label="Minimise table padding"
                                    ></hx-checkbox>
        </hx-content-card>
        <div class="d-flex flex-column">
            <hx-button
                                        left-icon="mdi-printer-outline"
                                        variant="primary"
                                        label="Print"
                                        class="mt-3"
                                        @click="handlePrintClick"
                                    ></hx-button>
            <hx-button
                                        left-icon="mdi-content-save-outline"
                                        variant="secondary"
                                        label="Export PDF"
                                        class="mt-3"
                                        @click="handleExportPDFClick"
                                    ></hx-button>
            <hx-button
                                        left-icon="mdi-update"
                                        variant="secondary"
                                        label="Reset to default"
                                        class="mt-3"
                                        @click="handleResetToDefaultClick"
                                    ></hx-button>
        </div>
        </hx-toolbar-body-section-content-block>
    </hx-toolbar>

    <v-main class="d-flex align-center justify-center">
        Content goes here
    </v-main>
    </v-layout>
</template>
</HxModal>
      `;
    return { code };
  },
  data() {
    return {
      tab: 'Modal Toolbar Usage',
      tabs: ['Modal Toolbar Usage'],
      showHxModalToolbar: false,
      collapseToolbar: false,
      repeatHeaderRow: false,
      minimiseTablePadding: false,
      screenshotPdfExport,
      selectedSize: [
        {
          title: '14',
          value: 14
        }
      ],
      size: [
        {
          title: '11',
          value: 11
        },
        {
          title: '12',
          value: 12
        },
        {
          title: '13',
          value: 13
        },
        {
          title: '14',
          value: 14
        }
      ],
      selectedSpacing: [
        {
          title: '1.15',
          value: 1.15
        }
      ],
      spacing: [
        {
          title: '1',
          value: 1
        },
        {
          title: '1.15',
          value: 1.15
        },
        {
          title: '1.25',
          value: 1.25
        },
        {
          title: '1.35',
          value: 1.35
        }
      ]
    };
  },
  methods: {
    handlePrintClick() {
      console.log('Print clicked');
    },
    handleExportPDFClick() {
      console.log('Export PDF clicked');
    },
    handleResetToDefaultClick() {
      console.log('Reset to default clicked');
    }
  }
};
</script>

<style scoped lang="scss">
.preview-panel {
  outline: 2px solid rgb(var(--v-theme-secondary-darken-1));
  border-radius: 12px;
}
</style>
